import { environment } from './../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class ResultsService {

  private offersUrl = `${environment.backendRoot}/webresources/frontend/entity.bookingoffer/getOfferCollection/`;
  private bookingUrl = `${environment.backendRoot}/webresources/frontend/entity.bookingofferroom/`;
  private offersPaginateUrl = `${environment.backendRoot}/webresources/frontend/entity.bookingoffer/getOfferCollectionPaging/`;
  private propertyUrl = `${environment.backendRoot}/webresources/frontend/entity.bookingofferroom/propertyResult/`;
  private propertyPreviewUrl = `${environment.backendRoot}/webresources/frontend/entity.bookingofferroom/owner_property_preview/`;
  private applicationFormUrl = `${environment.backendRoot}/webresources/frontend/entity.hotel/propertyRegistrationPublic/`;
  private contactUsUrl = `${environment.backendRoot}/webresources/frontend/entity.users/contact-us/`;
  private requestUniqueOfferUrl = `${environment.backendRoot}/webresources/frontend/entity.bookingrequest/requestoffer/`;


  constructor(private http: HttpClient) { }

  getOffers(offerId: string): Observable<any> {
    const url = this.offersUrl + offerId;
    return this.http.get(url,
      {
        headers: new HttpHeaders()
          .set('Content-Type', 'application/json')
      }
    );
  }
  getOffersPaginate(offerId: string, offset, limit): Observable<any> {
    const url = this.offersPaginateUrl + offerId + '/' + offset + '/' + limit;
    console.log(url);
    return this.http.get(url,
      {
        headers: new HttpHeaders()
          .set('Content-Type', 'application/json')
      }
    );
  }

  saveBookingInfo(hotelId: string, bookingInfo): Observable<any> {
    const url = this.bookingUrl + hotelId;
    const data = JSON.stringify(bookingInfo);
    return this.http.put(url, data,
      { headers: new HttpHeaders().set('Content-Type', 'application/json') }
    );
  }
  goToBooking(hotelid, data, bookingInfo): Observable<any> {
    const url = this.bookingUrl + 'finalBooking/' + hotelid + '/' + encodeURIComponent(encodeURIComponent(JSON.stringify(data)));
    const dataForPut = JSON.stringify(bookingInfo);
    return this.http.put(url, dataForPut,
      { headers: new HttpHeaders().set('Content-Type', 'application/json') }
    );
  }
  getProperty(data) {
    const url = this.propertyUrl + encodeURIComponent(encodeURIComponent(JSON.stringify(data)));
    // console.log(decodeURIComponent(decodeURIComponent(url)));
    return this.http.post(url,
      {
        headers: new HttpHeaders()
          .set('Content-Type', 'application/json')
      }
    );
  }
  getPropertyPreview(data) {
    const url = this.propertyPreviewUrl + data;
    return this.http.get(url,
      {
        headers: new HttpHeaders()
          .set('Content-Type', 'application/json')
      }
    );
  }
  sendApplicationForm(data) {
    const url = this.applicationFormUrl + encodeURIComponent(encodeURIComponent(JSON.stringify(data)));
    // console.log(decodeURIComponent(decodeURIComponent(url)));
    return this.http.get(url,
      {
        headers: new HttpHeaders()
          .set('Content-Type', 'application/json')
      }
    );
  }

  requestUniqueOffer(propID, reqID) {
    const url = this.requestUniqueOfferUrl + propID + '/' + reqID;
    return this.http.get(url,
      {
        headers: new HttpHeaders()
          .set('Content-Type', 'application/json')
      }
    );
  }

  sendContactUs(data) {
    const url = this.contactUsUrl + encodeURIComponent(encodeURIComponent(JSON.stringify(data)));
    // console.log(decodeURIComponent(decodeURIComponent(url)));
    return this.http.get(url,
      {
        headers: new HttpHeaders()
          .set('Content-Type', 'application/json')
      }
    );
  }
}
